import React, { useEffect, useRef, useState } from "react";

import { Button, Container, Row, Col, Card, Spinner } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import "./Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaw, faMicrochip, faRobot } from "@fortawesome/free-solid-svg-icons";

import heroImgBlack from "../../assets/images/black1.png";
import heroImgWhite from "../../assets/images/white1.png";

import { startProductCheckout } from "../../lib/store";




export default function Home({ isAuthenticated }) {
  const navigate = useNavigate();
  const [greeting, setGreeting] = useState("");
const [buyingColor, setBuyingColor] = useState(null);


const checkoutLockRef = useRef(false);
  const swipeRef = useRef(null);
  const feedingRef = useRef(null);

  const scrollToCard = (index) => {
  const viewport = swipeRef.current;
  if (!viewport) return;

  const track = viewport.querySelector(".hero-snap-track");
  if (!track) return;

  const slides = track.querySelectorAll(".hero-snap-slide");
  const target = slides[index];
  if (!target) return;

  // Scroll the viewport horizontally so the target slide aligns to the left
  viewport.scrollTo({
    left: target.offsetLeft - track.offsetLeft,
    behavior: "smooth",
  });
};


useEffect(() => {
  const el = swipeRef.current;
  if (!el) return;

  const onWheel = (e) => {
    // Only hijack when there's something to scroll horizontally
    const canScroll = el.scrollWidth > el.clientWidth;
    if (!canScroll) return;

    // If user is already doing horizontal wheel (trackpads), let it behave naturally
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

    // Convert vertical wheel into horizontal scroll
    e.preventDefault();
    el.scrollLeft += e.deltaY;
  };

  // Need { passive: false } so preventDefault works
  el.addEventListener("wheel", onWheel, { passive: false });
  return () => el.removeEventListener("wheel", onWheel);
}, []);

  // Sold out state (only updates after user tries to buy)
  const [soldOutColors, setSoldOutColors] = useState({
    black: false,
    white: false,
  });

  // Swipe slider index (0=black, 1=white)
  const [swipeIndex, setSwipeIndex] = useState(0);

  const [activeColor, setActiveColor] = useState("black");


const actuallyBuy = async (color) => {
  if (checkoutLockRef.current) return;
  checkoutLockRef.current = true;

  let didRedirect = false;

  try {
    if (soldOutColors[color]) return;

    setBuyingColor(color); // ✅ show overlay immediately

    const priceId = priceMap[color];
    if (!priceId) {
      console.warn("Missing priceId for color:", color);
      return;
    }

    const result = await startProductCheckout(priceId, { color, quantity: 1 });

    if (!result?.ok) {
      if (result?.outOfStock) {
        setSoldOutColors((prev) => ({ ...prev, [color]: true }));
      }
      console.warn("Checkout not started:", result?.message);
      return;
    }

    // ✅ Redirect and keep overlay
    didRedirect = true;
    window.location.assign(result.url);
  } catch (err) {
    console.error("Checkout failed:", err);
  } finally {
    // Only clear overlay if we did NOT redirect
    if (!didRedirect) {
      setBuyingColor(null);
    }

    // Prevent rapid double taps
    setTimeout(() => {
      checkoutLockRef.current = false;
    }, 600);
  }
};





useEffect(() => {
  const el = feedingRef.current;
  if (!el) return;

  // 1) Wheel -> horizontal scroll (desktop trackpads/mice)
  const onWheel = (e) => {
    const canScroll = el.scrollWidth > el.clientWidth;
    if (!canScroll) return;

    // if user is already scrolling horizontally, let it be
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

    e.preventDefault();
    el.scrollLeft += e.deltaY;
  };

  // 2) Mouse drag to scroll
  let isDown = false;
  let startX = 0;
  let startLeft = 0;

  const onMouseDown = (e) => {
    isDown = true;
    el.classList.add("is-dragging");
    startX = e.pageX;
    startLeft = el.scrollLeft;
  };

  const onMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const dx = e.pageX - startX;
    el.scrollLeft = startLeft - dx;
  };

  const stop = () => {
    isDown = false;
    el.classList.remove("is-dragging");
  };

  el.addEventListener("wheel", onWheel, { passive: false });
  el.addEventListener("mousedown", onMouseDown);
  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", stop);
  el.addEventListener("mouseleave", stop);

  return () => {
    el.removeEventListener("wheel", onWheel);
    el.removeEventListener("mousedown", onMouseDown);
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", stop);
    el.removeEventListener("mouseleave", stop);
  };
}, []);


// detect “desktop-like” pointer
const isDesktopPointer =
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches;




  // Prices (edit these to match your real offer)
  const PRICE_WAS = 23.99;
  const PRICE_NOW = 2.99;

  // Price IDs from env
  const priceMap = {
    black: process.env.REACT_APP_PRODUCT_PRICE_SMARTTAG_BLACK,
    white: process.env.REACT_APP_PRODUCT_PRICE_SMARTTAG_WHITE,
  };

  // Two swipe cards
  const swipeCards = [
    {
      color: "black",
      src: heroImgBlack,
      alt: "Little Paws Place SmartTag – Black",
      priceId: priceMap.black,
    },
    {
      color: "white",
      src: heroImgWhite,
      alt: "Little Paws Place SmartTag – White",
      priceId: priceMap.white,
    },
  ];

  // Greeting
  useEffect(() => {
    const hour = new Date().getHours();
    if (hour < 12) setGreeting("Good morning ☀️");
    else if (hour < 18) setGreeting("Good afternoon 🌞");
    else setGreeting("Good evening 🌙");
  }, []);

  // Helper: send to login if not authed, otherwise go to target path
  const goOrAuth = (path) => {
    if (isAuthenticated) navigate(path);
    else navigate("/login");
  };

const handleCardPress = async (color) => {
  const index = color === "white" ? 1 : 0;

  // Desktop: click selects/scrolls
  if (isDesktopPointer) {
    setActiveColor(color);
    scrollToCard(index);
    return;
  }

  // Mobile: tap buys immediately
  await actuallyBuy(color);
};


const handleCardDoubleClick = async (color) => {
  if (!isDesktopPointer) return; // safety
  await actuallyBuy(color);
};





  // Marketing tiles (unchanged)
  const tiles = [
    {
      title: "Lost pet protection",
      icon: faMicrochip,
      subtitle: "SmartTag + instant owner contact",
      bullets: [
        "Scannable SmartTag links directly to your pet’s profile",
        "Finder can contact you without seeing your phone number",
        "Location + scan history for faster recovery",
      ],
      path: "/subscribe",
    },
    {
      title: "Health & care tracking",
      icon: faPaw,
      subtitle: "All your pet info in one place",
      bullets: [
        "Vet appointments and vaccine reminders",
        "Document storage for records & lab results",
        "Behavior notes, diet history, and care instructions",
      ],
      path: "/subscribe",
    },
    {
      title: "AI-powered Paw assistant",
      icon: faRobot,
      subtitle: "24/7 coaching for real life",
      bullets: [
        "Ask care questions anytime — day or night",
        "Get behavior, training, and nutrition tips",
        "Simple language, made for busy pet parents",
      ],
      path: "/subscribe",
    },
  ];

  return (
    <div className="landing-wrapper">
      {/* Hero Section */}
      <section className="hero-section text-center d-flex align-items-center justify-content-center">
        <Container>
          {/* Hero video (silent, autoplay, no layout shift) */}
{/* SmartTag Activation Notice (compact, web uses camera) */}
{/* SmartTag Setup Video (replace old Activate SmartTag box) */}
<motion.div
  className="hero-activate-compact"
  initial={{ opacity: 0, y: 8 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.45 }}
  aria-label="SmartTag setup video"
>
  <div className="hero-activate-video-wrap">

    <div className="hero-activate-video-head">
      <div className="hero-activate-pill">
        <FontAwesomeIcon icon={faMicrochip} className="me-2" />
        Easy SmartTag Setup
      </div>

      <div className="hero-activate-compact-title">
        Scan your SmartTag. Create a password. Done.
      </div>

      <div className="hero-activate-compact-sub">
        Watch this quick setup guide and activate your SmartTag in under a minute.
      </div>
    </div>

    <div className="hero-activate-video-box">
<video
  controls
  playsInline
  preload="metadata"
  poster="/images/smarttag-video-cover.png"
  className="hero-activate-video"
>
  <source src="/videos/smarttag-setup.mp4" type="video/mp4" />
  Your browser does not support video playback.
</video>
    </div>

    <div className="hero-activate-compact-actions">
      <Button
        variant="outline-light"
        size="sm"
        className="hero-activate-mini-btn"
        onClick={() => navigate("/contact-support")}
      >
        Need Help?
      </Button>

      <Button
        variant="light"
        size="sm"
        className="hero-activate-mini-btn"
        onClick={() => {
          const el = swipeRef.current;
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }}
      >
        View SmartTag
      </Button>
    </div>

  </div>
</motion.div>


          {/* Swipeable product cards */}
          <div className="hero-animation-wrapper">
            <div className="hero-carousel-frame hero-swipe-card-frame">

        <div className="hero-swipe-viewport" ref={swipeRef}>

  <div className="hero-snap-track">
    {swipeCards.map((card) => {
      const isSoldOut = soldOutColors[card.color];

      return (
<div
  key={card.color}
  className={
    "hero-snap-slide" +
    (activeColor === card.color ? " hero-snap-slide-active" : "")
  }
  role="button"
  tabIndex={0}
  aria-label={`Buy SmartTag in ${card.color}`}
  onClick={() => handleCardPress(card.color)}
  onDoubleClick={() => handleCardDoubleClick(card.color)}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCardPress(card.color);
    }
  }}
>
  {/* Price overlay */}
  <div className="hero-card-price-badge">
    <span className="hero-card-price-was">${PRICE_WAS}</span>
    <span className="hero-card-price-now">${PRICE_NOW}</span>
  </div>

  {/* Sold out overlay */}
  {isSoldOut && <div className="hero-card-soldout">SOLD OUT</div>}

  {/* ✅ Buying overlay */}
{buyingColor === card.color && (
  <div className="hero-card-buying">
    <Spinner animation="border" size="sm" className="me-2" />
    Opening secure checkout…
  </div>
)}


  <img
    src={card.src}
    alt={card.alt}
    className={"hero-snap-img" + (isSoldOut ? " is-soldout" : "")}
    draggable={false}
  />
</div>

      );
    })}
  </div>
</div>



              {/* Optional tiny hint (comment out if you want nothing) */}
            <div
  className="hero-swipe-hint"
  onClick={(e) => e.stopPropagation()}
  onPointerDown={(e) => e.stopPropagation()}
>
  Swipe for next • Tap to buy (2.99 is Shipping Only)

</div>

            </div>
          </div>

          <div className="mb-2">
            <span className="hero-kicker">AI-Powered SmartTag Platform</span>
          </div>

         <motion.h1
  className="display-5 fw-bold mb-3 hero-title hero-title-lightning"
  initial={{ opacity: 0, y: 10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.7, delay: 0.1 }}
>
  Smart Pet Identity Starts Here <span className="paw-emoji">🐾</span>
</motion.h1>


          <motion.p
            className="lead mb-3 hero-subtitle"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            One SmartTag, one AI assistant — everything your pet needs to stay safe
            and connected.
          </motion.p>
          <motion.div
  className="hero-app-coming-soon"
  initial={{ opacity: 0, y: 10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.7, delay: 0.28 }}
>
  <span className="hero-app-coming-pill">
  📱 iOS + Android app coming soon
</span>
</motion.div>

          <div className="d-flex justify-content-center gap-3 flex-wrap hero-cta-group mt-3">
            <Button variant="outline-light" size="lg" onClick={() => navigate("/plans")}>
              View plans
            </Button>

            <Button variant="outline-light" size="lg" onClick={() => goOrAuth("/smarttag")}>
              Open Paw Assistant
            </Button>
          </div>
        </Container>
      </section>

      {/* Greeting section */}
      <section className="text-center py-5 home-greeting-section">
        <Container>
          <h2 className="mb-2">{greeting}</h2>
          <p className="text-muted mb-0">
            Welcome to Little Paws Place — your hub for SmartTag activation,
            AI-powered pet help, and keeping every pet in your household organized
            in one place.
          </p>
        </Container>
      </section>
      {/* =========================================================
    AI Feeding Plan Highlight (Homepage Section)
    Drop this block right AFTER the hero section and BEFORE tiles
   ========================================================= */}
<section className="home-ai-feeding-section py-5">
  <Container>
    <Row className="justify-content-center">
      <Col lg={9} xl={8}>
        <div className="ai-feeding-card">
          <div className="ai-feeding-top">
            <div className="ai-feeding-badge">✨ NEW • AI FEATURE</div>

            <h2 className="ai-feeding-title">
              AI feeding plans that fit your pet’s real life
            </h2>

            <p className="ai-feeding-subtitle">
              Paw uses your pet’s weight, age, goals, meals/day, and food details to
              generate a personalized plan — then keeps you on track.
            </p>
          </div>

          <div className="ai-feeding-feature-grid">
            <div className="ai-feeding-feature">
              <div className="ai-feeding-icon">🔥</div>
              <div>
                <div className="ai-feeding-feature-title">Daily calories</div>
                <div className="ai-feeding-feature-text">Tailored to your pet’s size + goal.</div>
              </div>
            </div>

            <div className="ai-feeding-feature">
              <div className="ai-feeding-icon">🥣</div>
              <div>
                <div className="ai-feeding-feature-title">Cups per meal</div>
                <div className="ai-feeding-feature-text">Exact portions split by meals/day.</div>
              </div>
            </div>

            <div className="ai-feeding-feature">
              <div className="ai-feeding-icon">⏰</div>
              <div>
                <div className="ai-feeding-feature-title">One-time reminders</div>
                <div className="ai-feeding-feature-text">Food check-ins when you need them.</div>
              </div>
            </div>

            <div className="ai-feeding-feature">
              <div className="ai-feeding-icon">🛒</div>
              <div>
                <div className="ai-feeding-feature-title">Reorder links</div>
                <div className="ai-feeding-feature-text">Quick re-up when it’s time.</div>
              </div>
            </div>
          </div>

          <div className="ai-feeding-cta-row">
            <Button className="ai-feeding-primary" size="lg" onClick={() => goOrAuth("/feeding")}>
              Try an AI feeding plan
            </Button>

            <Button
              variant="outline-dark"
              size="lg"
              className="ai-feeding-secondary"
              onClick={() => navigate("/plans")}
            >
              View plans
            </Button>
          </div>

          <div className="ai-feeding-footnote">
            Private, fast, and built for busy pet parents.
          </div>
        </div>
      </Col>
    </Row>
  </Container>
</section>



      {/* Marketing Tiles */}
      <section className="tile-section py-5">
        <Container>
          <Row className="justify-content-center g-4">
            {tiles.map((tile) => (
              <Col
                key={tile.title}
                xs={12}
                sm={10}
                md={6}
                lg={4}
                className="d-flex justify-content-center mx-auto"
                style={{ display: "flex" }}
              >
                <motion.div
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                  style={{ width: "100%", maxWidth: 260 }}
                >
                  <Card
                    className="text-center h-100 tile"
                    style={{
                      width: "100%",
                      maxWidth: "260px",
                      cursor: "pointer",
                    }}
                    onClick={() => goOrAuth(tile.path)}
                  >
                    <Card.Body>
                      <div className="tile-icon-wrap">
                        <FontAwesomeIcon icon={tile.icon} size="lg" />
                      </div>
                      <Card.Title>{tile.title}</Card.Title>
                      <p className="text-muted small mb-2">{tile.subtitle}</p>
                      <ul
                        className="text-start mb-0"
                        style={{
                          listStyle: "disc",
                          paddingLeft: "1.2rem",
                          fontSize: "0.9rem",
                          color: "#4b5563",
                        }}
                      >
                        {tile.bullets.map((b) => (
                          <li key={b}>{b}</li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
<div className="home-fab-stack">
  <button
    type="button"
    className="home-found-pill"
    onClick={() => navigate("/found")}
  >
    Found a pet? <span className="home-found-cta">Contact owner</span>
  </button>

  <button
    type="button"
    className="home-support-bubble"
    onClick={() => navigate("/contact-support")}
  >
    Need help? <span className="home-support-cta">Contact Support</span>
  </button>
</div>

    </div>
  );
}